"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const react_redux_1 = require("react-redux");
const src_1 = require("@rover/ts-bootstrap/dist/src");
const reducers_1 = require("../../reducers");
const getFrequencyLimitCopy_1 = require("../utils/getFrequencyLimitCopy");
const FrequencyLimitLabel = ({ automatedLimits, limitType, }) => {
    const getLimitCopy = () => {
        if (limitType !== 'No more than...') {
            return limitType;
        }
        return automatedLimits
            .reduce((prev, curr, index) => {
            if (index === 0) {
                return prev.concat(`No more than ${getFrequencyLimitCopy_1.default(curr).toLowerCase()}`);
            }
            if (index === 1) {
                return prev.concat(getFrequencyLimitCopy_1.default(curr).toLowerCase());
            }
            return prev;
        }, [])
            .join(', ');
    };
    return (React.createElement("div", { style: { display: 'flex' } },
        React.createElement(src_1.Text, { size: "small", text: `${getLimitCopy()}${automatedLimits.length > 2 ? ', ' : ''}`, textStyle: {
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                width: '100%',
            } }),
        automatedLimits.length > 2 && (React.createElement(src_1.Text, { size: "small", text: `\u00A0 +${automatedLimits.length - 2} more`, textStyle: Object.assign(Object.assign({}, src_1.semibold), { color: src_1.turquoise }) }))));
};
const mapStateToProps = (state) => ({
    automatedLimits: reducers_1.getEditableCampaignFrequencyLimits(state),
    limitType: reducers_1.getAutomatedLimitType(state),
});
exports.default = react_redux_1.connect(mapStateToProps, {})(FrequencyLimitLabel);
